import { Box, Chip, Typography } from "@mui/material";
import { getDiagnosisGradeColor } from "data/data";
import { useTranslation } from "react-i18next";
import MainCard from "components/MainCard";

const DiagnosisPartCard = ({ data }) => {
    const { t } = useTranslation();
    if (!data) return null;

    const lowest = data.lowestDiagnosisRank;
    return (
        <MainCard content={false} className="squarebox">
            <div 
                className="alert_phrase"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    height: "100%",          // 부모 높이에 맞춰 분배 (필요 시 px로 지정 가능)
                    padding: "14px 8px",     // 상하좌우 여백
                    boxSizing: "border-box"
                }}
            >
                <Chip 
                    label={t('message.common.title.iso.vibration.grade')} 
                    color="primary" 
                    sx={{
                        maxWidth: "100%",
                        height: "auto",               // Chip 고정 높이 해제
                        padding: "4px 0",             // 위아래 여백 추가
                        "& .MuiChip-label": {
                            whiteSpace: "normal",       // 줄바꿈 허용
                            wordBreak: "keep-all",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,         // 최대 2줄
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            lineHeight: 1.2
                        }
                    }}
                />
                
                <Box className="charts_card">
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "42px",       // A, B, C 등 강조 폰트 크기
                            // fontWeight: "bold",
                            lineHeight: 1           // 수직 중앙 맞춤용
                        }}
                        className={`no_circle ${getDiagnosisGradeColor(lowest)}`}
                    >
                        {lowest}
                    </Box>
                </Box>
                {/* 3단계: 하단 (위치/자재 등 추가 설명) */}
                <Typography 
                    variant="body2" 
                    sx={{ 
                        color: "#ccc",          // 밝은 회색 텍스트
                        fontSize: "14px",
                        textAlign: "center"
                    }}
                >
                    {data.componentLocation.name+'-'+data.masterEquipmentPart.name}
                </Typography>
            </div>
        </MainCard>
    );
}

export default DiagnosisPartCard;